import PageMeta from "@/components/seo/PageMeta";
import SectionHeading from "@/components/ui/SectionHeading";
import { privacyPolicyContent } from "@/data/content";
import { useContent } from "@/hooks/useContent";

export default function PrivacyPolicyPage() {
  const content = useContent("pages/privacy-policy", privacyPolicyContent);
  return (
    <>
      <PageMeta
        title="Privacy Policy — Chasing Provence Retreats"
        description="Privacy policy for Chasing Provence Retreats — how we collect, use, and protect your information."
        noindex
      />

      <div className="min-h-screen bg-parchment px-6 pt-32 pb-20 lg:px-12 lg:pt-40 lg:pb-32">
        <div className="mx-auto max-w-3xl">
          <SectionHeading
            scriptAccent={content.scriptAccent}
            heading={content.heading}
          />

          <p className="mb-16 text-center font-body text-sm text-warm-stone">
            Last updated: {content.lastUpdated}
          </p>

          <div className="space-y-12">
            {content.sections.map((section, i) => (
              <section key={i}>
                <h3 className="mb-4 font-serif text-xl font-light tracking-wide text-soft-charcoal lg:text-2xl">
                  {section.title}
                </h3>
                {section.paragraphs.map((p, j) => (
                  <p
                    key={j}
                    className="mb-3 font-body text-sm leading-relaxed text-soft-charcoal/75 last:mb-0"
                  >
                    {p}
                  </p>
                ))}
              </section>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
